import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import MuiLink from '@material-ui/core/Link';
// Internal
import { getInternalLink, getMuiColor } from './internal/Tools';

const Link = ({
  primary, secondary, inherit, path, mailto, tel, children, ...otherProps
}) => {
  const color = getMuiColor(primary, secondary, inherit);

  // Component props
  const linkProps = { color, ...otherProps };

  if (!!mailto || !!tel) {
    let href;
    if (mailto) {
      href = `mailto:${mailto}`;
    } else if (tel) {
      href = `tel:${tel}`;
    }

    return (
      <MuiLink
        {...linkProps}
        href={href}
      >
        { children }
      </MuiLink>
    );
  }

  return (
    <MuiLink
      {...linkProps}
      component={path ? getInternalLink(path) : 'button'}
    >
      { children }
    </MuiLink>
  );
};

Link.propTypes = {
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  inherit: PropTypes.bool,
  path: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      targetBlank: PropTypes.bool.isRequired,
    }),
  ]),
  mailto: PropTypes.string,
  tel: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Link.defaultProps = {
  primary: true,
  secondary: false,
  inherit: false,
  path: null,
  mailto: null,
  tel: null,
};

export default React.memo(Link);



// WEBPACK FOOTER //
// ./components/core/Link.js